import block from 'bem-cn';
import areRangesOverlapping from 'date-fns/are_ranges_overlapping';
import differenceInCalendarDays from 'date-fns/difference_in_calendar_days';
import isSameDay from 'date-fns/is_same_day';
import isWithinRange from 'date-fns/is_within_range';
import min from 'date-fns/min';
import React, { Component } from 'react';
import { DAY_BOTTOM_PADDING, DAY_TOP_PADDING, TASK_HEIGHT, TASK_OFFSET } from '../../constants';
import Day from '../Day';
import TaskContainer from '../../Containers/TaskContainer';
import startOfDay from 'date-fns/start_of_day';

const b = block('Week')

export default class Week extends Component {
    getTaskOffset(id) {
        for (let i = 0; i < 7; i++) {
            if (Number.isInteger(this.props.map[i][id])) {
                return this.props.map[i][id]
            }
        }

        return null
    }

    getTasksForDay = date => {
        const { currentTask, tasks, colors, map } = this.props
        const dayTasks = []
        const _date = startOfDay(date)
        tasks
            .filter(
                task =>
                    isSameDay(_date, task.startDate) ||
                    isWithinRange(_date, task.startDate, task.endDate)
            )
            .forEach((task) => {
                if (
                    isSameDay(task.startDate, _date) ||
                    (_date.getDay() === 0 && _date > task.startDate)
                ) {
                    dayTasks.push(
                        <TaskContainer
                            key={task.id}
                            {...task}
                            color={colors[task.calendar]}
                            offset={(map[_date.getDay()][task.id] || 0) * (TASK_HEIGHT + TASK_OFFSET)}
                            date={_date}
                            draggable={true}
                            disabled={currentTask && currentTask.id === task.id}
                            inactive={!!currentTask}
                            resizeLeft={isSameDay(task.startDate, _date)}
                            resizeRight={task.endDate <= this.props.endDate}
                            size={differenceInCalendarDays(min(this.props.endDate, task.endDate), _date) + 1}
                        />
                    )

                }
            })

        if (
            currentTask &&
            this.isWeekTask(currentTask, this.props.startDate, this.props.endDate) &&
            ((_date.getDay() === 0 && _date > currentTask.startDate) ||
                isSameDay(currentTask.startDate, _date))
        ) {
            const currentOffset = this.getTaskOffset(currentTask.id)
            dayTasks.push(
                <TaskContainer
                    key={-1}
                    {...currentTask}
                    color={colors[currentTask.calendar]}
                    offset={(currentOffset || 0) * (TASK_HEIGHT + TASK_OFFSET)}
                    resizing={true}
                    date={_date}
                    resizeLeft={isSameDay(currentTask.startDate, _date)}
                    resizeRight={currentTask.endDate <= this.props.endDate}
                    size={differenceInCalendarDays(min(this.props.endDate, currentTask.endDate), _date) + 1}
                />
            )
        }
        return dayTasks
    }

    isWeekTask(task, weekStartDate, weekEndDate) {
        if (isSameDay(task.startDate, task.endDate)) {
            return isWithinRange(task.startDate, weekStartDate, weekEndDate)
        } else {
            return (
                isSameDay(weekStartDate, task.endDate) ||
                isSameDay(weekEndDate, task.startDate) ||
                areRangesOverlapping(weekStartDate, weekEndDate, task.startDate, task.endDate)
            )
        }
    }

    getDayHeight() {
        let max = 0
        const { map } = this.props
        for (let i = 0; i < 7; i++) {
            let day = map[i]
            let dayMax = Math.max.apply(null, Object.values(day))

            if (dayMax > max) {
                max = dayMax
            }
        }

        return (
            (max + 1) * (TASK_HEIGHT + TASK_OFFSET) +
            DAY_TOP_PADDING +
            (DAY_BOTTOM_PADDING - TASK_OFFSET)
        )
    }

    render() {
        const { days, tasks, currentTask } = this.props
        return (
            <div
                className={b()}
                style={{
                    height: this.getDayHeight()
                }}
            >
                {days.map(day => (
                    <Day key={day.date.getDay()} {...day}>
                        {(tasks.length || currentTask) && this.getTasksForDay(day.date)}
                    </Day>))
                }
            </div>
        )
    }
}
